import { FC } from "react";

import TiledBlockH1 from "@/components/BentoList/TiledBlockH1";
import TiledBlockHWithImage from "@/components/BentoList/TiledBlockHWithImage";
import TiledBlockV3 from "@/components/BentoList/TiledBlockV3";
import TiledBlockV4 from "@/components/BentoList/TiledBlockV4";
import TiledBlockV5 from "@/components/BentoList/TiledBlockV5";
import TiledBlockVWithImage from "@/components/BentoList/TiledBlockVWithImage";
import { BentoBlockProps, BentoTextElement, EditorialModuleImage } from "@/types";

const BentoBlock: FC<BentoBlockProps> = ({ block }) => {
  const { elements, layout } = block;

  const imageCounter = elements.filter((element) => element.type === "editorialModuleImage").length;
  const textCounter = elements.filter((element) => element.type === "bentoTextElement").length;
  let blockTag;
  let verticalBlock = false;
  switch (true) {
    case imageCounter === 0 && textCounter === 4:
      blockTag = <TiledBlockH1 items={elements as BentoTextElement[]} />;
      break;
    case imageCounter === 1 && textCounter === 0:
      blockTag = <TiledBlockV4 items={elements as EditorialModuleImage[]} />;
      verticalBlock = true;
      break;
    case imageCounter === 0 && textCounter === 2:
      blockTag = <TiledBlockV5 items={elements as BentoTextElement[]} />;
      verticalBlock = true;
      break;
    case imageCounter === 2 && textCounter === 0 && layout === "Vertical":
      blockTag = <TiledBlockV3 items={elements as EditorialModuleImage[]} />;
      break;
    case layout === "Horizontal":
      blockTag = <TiledBlockHWithImage items={elements.slice(0, 3)} />;
      break;
    case layout === "Vertical":
      blockTag = <TiledBlockVWithImage items={elements.slice(0, 3)} />;
      break;
    default:
      blockTag = null;
      break;
  }
  return (
    <div
      /* className={`relative overflow-hidden max-h-[510px] md:max-h-full ${verticalBlock ? "w-[74dvw] md:w-[20.5dvw]" : "w-[135dvw] md:w-[41.4dvw]"}`} */
      className={`relative overflow-hidden  ${verticalBlock ? "w-[300px] md:w-[20.5dvw]" : "w-[600px] md:w-[41.4dvw]"}`}
    >
      {blockTag}
    </div>
  );
};

export default BentoBlock;
